import React, {Fragment, useContext} from 'react'
import { useTranslation } from 'react-i18next'

import Divider from 'components/Divider'
import { Checkbox } from 'components/forms'
import { Row, Col } from 'react-flexbox-grid'
import Button from 'components/Button'
import { ReceiptContext } from '../pages/Bill'

const ClosingBillFilter = (props) => {
	const { clearFilter, formState, formApi } = props
	const [t] = useTranslation()
	const selected = Object.keys(formState.values)[0]
	const { setFilters } = useContext(ReceiptContext)
	const handleCheck = e => {
		formApi.reset()
		if(e.target.checked) {
			formApi.setValues({
				[e.target.name]: true
			})
		}
	}
	const handleSubmit = () => {
		setFilters(formApi.getValues())
	}

	const handleCancel = () => {
		clearFilter()
		setFilters({})
	}
	return (
		<Fragment>
			<Divider height={10} inverted />
			<Row>
				<Col xs={6}>
					<Checkbox onChange={handleCheck} noForm checked={!Object.keys(formState.values)[0]} label={t('closing_section.strings.bill_filter_all')}/>
					<Divider visible height={20} inverted />
					<Checkbox onChange={handleCheck} checked={selected === 'isCancelledBill'} field='isCancelledBill' label={t('closing_section.strings.bill_filter_canceled')}/>
					<Divider visible height={20} inverted />
					<Checkbox onChange={handleCheck} checked={selected === 'isNormalRate'} field='isNormalRate' label={t('closing_section.strings.bill_filter_normal_rate')}/>
					<Checkbox onChange={handleCheck} checked={selected === 'isReducedRate'} field='isReducedRate' label={t('closing_section.strings.bill_filter_reduced_rate')}/>
					<Divider visible height={20} inverted />
					<Checkbox onChange={handleCheck} checked={selected === 'isForeignCurrency'} field='isForeignCurrency' label={t('closing_section.strings.bill_filter_foreign_currency')}/>
					<Divider height={20} inverted />
					<Button fWidth type='submit' onClick={handleSubmit} text={t('common.buttons.apply')} status='primary'/>
					<Divider height={10} inverted />
					<Button fWidth onClick={handleCancel} status='cancelation' text={t('common.buttons.clear_filter')}/>
				</Col>
				<Col xs={6}>
					<Checkbox onChange={handleCheck} checked={selected === 'isCreditCard'} field='isCreditCard' label={t('closing_section.strings.bill_filter_credit_card')}/>
					<Checkbox onChange={handleCheck} checked={selected === 'isLoyaltiCard'} field='isLoyaltiCard' label={t('closing_section.strings.bill_filter_loyalty_card')}/>
					<Checkbox onChange={handleCheck} checked={selected === 'isInHouseStatistic'} field='isInHouseStatistic' label={t('closing_section.strings.bill_filter_in_cafe')}/>
					<Divider visible height={20} inverted />
					<Checkbox onChange={handleCheck} checked={selected === 'isExpense'} field='isExpense' label={t('closing_section.strings.bill_filter_expense')}/>
					<Checkbox onChange={handleCheck} checked={selected === 'isTransfer'} field='isTransfer' label={t('closing_section.strings.bill_filter_transfer')}/>
				</Col>
			</Row>
		</Fragment>
	)
}

export default ClosingBillFilter
